import { Card, CardContent, CardHeader } from '@/components/ui/Card';
import { MailAccountsPicker } from '@/components/MailAccountsPicker';
import { Checkbox } from '@/components/ui/Checkbox';
import { useCurrentWorkspace } from '@/lib/workspace-context';
import { useWizardStore, type MailProviderKey } from '../lib/wizard-store';

const PROVIDERS: Array<{
  id: MailProviderKey;
  title: string;
  description: string;
}> = [
  {
    id: 'instantly',
    title: 'Instantly',
    description:
      'Execution fiable, webhooks replies, inbox et orchestration des campagnes depuis Dispatcher.',
  },
  {
    id: 'successai',
    title: 'Success.ai',
    description:
      'Provider deja present dans l’historique du produit, utile si tu veux garder un setup hybride.',
  },
];

export function W4_MailProviderAccounts() {
  const { currentWorkspace } = useCurrentWorkspace();
  const {
    mail_providers,
    mail_provider_email_account_ids,
    toggleMailProvider,
    setMailAccounts,
  } = useWizardStore();

  return (
    <div className="space-y-6" data-testid="mail-provider-accounts-step">
      <Card>
        <CardHeader
          title="Providers mail"
          subtitle="Choisis d’abord le ou les moteurs d’envoi, puis seulement ensuite les comptes relies a ces providers."
        />
        <CardContent className="grid gap-3" data-testid="mail-provider-selection">
          {PROVIDERS.map((provider) => {
            const checked = mail_providers.includes(provider.id);
            return (
              <div
                key={provider.id}
                className={`rounded-brand border p-4 transition-colors cursor-pointer ${
                  checked
                    ? 'border-brand-primary bg-brand-primary/5'
                    : 'border-brand-border bg-white hover:border-brand-primary/40'
                }`}
              >
                <div className="flex items-start gap-3">
                  <Checkbox
                    id={`mail-provider-${provider.id}`}
                    checked={checked}
                    onChange={() => toggleMailProvider(provider.id)}
                    label={provider.title}
                    description={provider.description}
                    data-testid={`mail-provider-${provider.id}`}
                  />
                </div>
              </div>
            );
          })}
          <p className="text-xs text-gray-500">
            Tu peux en choisir plusieurs. Les comptes proposes juste dessous seront filtres selon ta
            selection.
          </p>
        </CardContent>
      </Card>

      <Card>
        <CardHeader
          title="Comptes expediteurs"
          subtitle="Selectionne uniquement les comptes des providers choisis pour cette campagne."
        />
        <CardContent data-testid="mail-picker-section">
          {mail_providers.length === 0 ? (
            <div className="rounded-brand border border-dashed border-brand-border bg-gray-50 px-4 py-5 text-sm text-gray-500">
              Choisis au moins un provider juste au-dessus pour charger les comptes correspondants.
            </div>
          ) : currentWorkspace ? (
            <MailAccountsPicker
              workspaceId={currentWorkspace.id}
              providers={mail_providers}
              selected={mail_provider_email_account_ids}
              onChange={setMailAccounts}
            />
          ) : (
            <p className="text-sm text-gray-400">Chargement du workspace…</p>
          )}
        </CardContent>
      </Card>
    </div>
  );
}
